/* eslint-disable no-shadow */
import React, { useEffect, useState, useContext } from 'react';
import { swalMessages } from 'src/constants';
import { Context } from 'src/context/Contex';
import launchService from 'src/services/launchService';
import LaunchPage from 'src/pages/MaestrosPage/LaunchPage';
import swal from 'sweetalert';

const LaunchContainer = () => {
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(false);
  const [count, setCount] = useState(0);
  const dataTale = [];
  let count2 = count;
  const { permisos } = useContext(Context);

  const reloadReleases = async () => {
    const response = await launchService.getLaunch();
    if (response) {
      try {
        response.forEach((value) => {
          if (value.LANZAMIENTO == 'true') {
            setCount((count) => count + 1);
          }
          dataTale.push({
            LINEA: value.LINEA,
            LANZAMIENTO: value.LANZAMIENTO,
            tableData:
              value.LANZAMIENTO === 'true'
                ? { checked: true }
                : { checked: false },
          });
        });
      } catch (err) {
        console.log(err);
      }
    }
    setReleases(dataTale);
    setLoading(false);
  };

  const updateRelease = async (params) => {
    const newRelease = releases;
    if (count2 <= 12) {
      Object.assign(newRelease[params.tableData.id], {
        LANZAMIENTO: params.tableData.checked,
      });
      setReleases(newRelease);
      setUpdate(true);
      const response = await launchService.updateLauch(params);
      if (!response) {
        swal(swalMessages.GENERAL_ERROR);
      }
    } else {
      Object.assign(newRelease[params.tableData.id], {
        LANZAMIENTO: 'false',
        tableData: { checked: false, id: params.tableData.id },
      });
      swal(swalMessages.LAUNCH_ERROR);
    }
  };

  useEffect(() => {
    setUpdate(false);
  }, [update]);

  const onChangeState = (value) => {
    if (value.tableData.checked && count2 <= 12) {
      count2 += 1;
    }
    if (!value.tableData.checked) {
      count2 -= 1;
    }
    updateRelease(value);
  };

  useEffect(() => {
    setLoading(true);
    reloadReleases();
  }, []);

  return (
    <LaunchPage
      releases={releases}
      loading={loading}
      permisos={permisos}
      onChangeState={onChangeState}
    />
  );
};

export default LaunchContainer;
